






import Vue from 'vue'
import ChessCell from '@/components/ChessCell.vue'

export default Vue.extend({
  name: 'ChessRow',
  components: {ChessCell},
  props: {
    row: Number,
    cols: {type: Number, default: 8},
  },
})
